

export const TYPES = {
    EREEN: "EREEN",
    MONGOL: "MONGOL",
    EZENGUI: "EZENGUI",
    EZENDEE: "EZENDEE",
}


export const STATUS = {
    REQUESTED: "REQUESTED",
    APPROVED: "APPROVED",
    DECLINED: "DECLINED",
    PENDING: "PENDING"
}

export const MEDAL = {
    GOLD: "GOLD",
    SILVER: "SILVER",
    BRONZE: "BRONZE"
}

export const ADMIN = {
    MANAGER: "MANAGER",
    DIRECTOR: "DIRECTOR",
    JIN: "JIN",
    COMP_PLAY: "COMP_PLAY"
}